(function () {
    var $window = $(window);

    var section_sticky = {
        holder: $('.article-sections'),
        fragTopPos: 0,
        scrollValue: 0,
        stickyElmsBefore: 0,
        init: function () {
            section_sticky.stickyElmsBefore =
                $('header').height() +
                ($('.stickybar.coolBar.trans').length > 0 ? $('.stickybar.coolBar.trans').height() : 0);
            section_sticky.fragTopPos = section_sticky.holder.offset().top - section_sticky.stickyElmsBefore;
            section_sticky.scrollSec();
            section_sticky.sticky();
        },
        sticky: function () {
            section_sticky.stickyElmsBefore =
                $('header').height() +
                ($('.stickybar.coolBar.trans').length > 0 ? $('.stickybar.coolBar.trans').height() : 0);
            section_sticky.scrollValue = $window.scrollTop();

            if (section_sticky.scrollValue >= section_sticky.fragTopPos) {
                if (
                    $('.content-navigation').length > 0 &&
                    section_sticky.scrollValue + section_sticky.holder.height() + section_sticky.stickyElmsBefore >=
                        $('.content-navigation').offset().top
                ) {
                    section_sticky.holder.css({
                        top:
                            $('.content-navigation').offset().top -
                            section_sticky.scrollValue -
                            section_sticky.holder.height(),
                    });
                } else {
                    section_sticky.holder.addClass('makeSticky').css({
                        top: section_sticky.stickyElmsBefore,
                    });
                }
            } else {
                section_sticky.holder.removeClass('makeSticky').css({
                    bottom: 'initial',
                    top: 'initial',
                });
            }

            $('.article-sections a').click(function () {
                $('.article-sections ul li').removeClass('active');
                $(this).parent('li').addClass('active');
            });
        },
        scrollSec: function () {
            // call sticky on scroll
            $window.on('scroll', section_sticky.sticky);
        },
    };

    UX.section_sticky = section_sticky; // add to global namespace
})();
